import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "../service/auth-service";
import { filter, map, take } from "rxjs";
function getFinalReturnUrl(url: string): string {
  try {
    const query = url.split('?')[1];
    if (query) {
      const params = new URLSearchParams(query);
      if (params.has('returnUrl')) {
        return params.get('returnUrl')!; // unwrap inner returnUrl
      }
    }
  } catch (_) { }
  return url;
}
export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.user$.pipe(
    filter(user => user !== undefined),
    take(1),
    map(user => {
      const cleanReturnUrl = getFinalReturnUrl(state.url);
      if (user) {
        //  Email verification check
        // if (!user.emailVerified) {
        //   router.navigate(['/verify-email'], { queryParams: { returnUrl: cleanReturnUrl } });
        //   return false;
        // }

        //  Role check
        if (route.data['roles'] && !route.data['roles'].includes(user.role)) {
          router.navigate(['/']);
          return false;
        }

        return true; //  allowed
      }

      //  Not logged in

      router.navigate(['/sign-in'], { queryParams: { returnUrl: cleanReturnUrl } });
      return false;
    })
  );
};